import Core      from '@/core/Core';
import Price     from '@/core/types/Price';
import TimeStamp from '@/core/types/TimeStamp';

/**
 * Завершённый тендер для графика истории цен номенклатуры — облегчённая строка tenders.getPriceHistory.
 * Стартовая цена и лучшая ставка — в своих валютах, курс пересчёта на начало тендера
 */
class TenderPricePoint {
  id: number;

  startAt: TimeStamp;

  endAt: TimeStamp;

  priceStartCurrencyCode: string;

  priceStartFull: Price;

  /** Ставок не было — null */
  bestBidCurrencyCode: string | null;

  bestBidPrice: Price | null;

  sellersCount: number;

  static fromServer(data: any, result = new TenderPricePoint()): TenderPricePoint {
    result.id = data.id;
    result.startAt = Core.utils.hydrate(data.startAt, TimeStamp.fromServer)!;
    result.endAt = Core.utils.hydrate(data.endAt, TimeStamp.fromServer)!;
    result.priceStartCurrencyCode = data.priceStartCurrencyCode;
    result.priceStartFull = Price.fromServer(data.priceStartFull);
    result.bestBidCurrencyCode = data.bestBidCurrencyCode;
    result.bestBidPrice = Core.utils.hydrate(data.bestBidPrice, Price.fromServer);
    result.sellersCount = data.sellersCount;

    return result;
  }
}

export default TenderPricePoint;
